import useUserStore from "../../../../../zustand-stores/UserStore";
import { SuccessCard } from "../SuccessCard";

export const Step9 = ({ questions = [] }) => {
  const { user } = useUserStore();

  return (
    <div>
      <SuccessCard
        title={`Good Job, ${user?.full_name ?? "User"}!`}
        description="War Map conquered, you're making amazing progress!"
      />
    </div>
  );
};
